import clsx from "clsx"
import React from "react"
import ICONS from "../../assets/icons"
import './SelectInput.scss'
import { Loader } from '../../components'

const CustomMultiSelectInput = ({
  options = [],
  span = [],
  onChange,
  onChangeHandle,
  placeholder = 'Choose',
  disabled = false,
  searchValue,
  loadingUsers,
  onSearchChange,
  fetchMoreOnScroll,
}) => {
  const [showMore, setShowMore] = React.useState(false)
  const dropdownRef = React.useRef()
  const wrapperRef = React.useRef()

  const btnHandler = () => {
    setShowMore(prev => !prev)
  }

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      fetchMoreOnScroll?.()
    }
  }

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target)
      ) {
        setShowMore(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div ref={wrapperRef} className={clsx('multiSelectInput', showMore && 'multiSelectInput-more')}>
      <button
        onClick={btnHandler}
        type='button'
        className='multiSelectInput__btn'
      >
        <span className={span.length > 0 ? 'customSpan spanWrapper' : 'customPlaceholder'}>
          {span.length > 0 ? span.join(', ') : placeholder}
        </span>
        {ICONS.utils.smallArrow}
      </button>

      {showMore && (
        <div
          className='multiSelectInput__dropdown'
          onScroll={handleScroll}
          ref={dropdownRef}
        >
          <input
            type='text'
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder='Search users...'
          />
          <ul>
            {loadingUsers ? (
              <div className="PROstatusModal__loader">
                <Loader />
              </div>
            ) : (
              options.map((item) => (
                <li key={item.value}>
                  <button
                    type="button"
                    className={span.includes(item.title) ? 'selectedActive' : ''}
                    onClick={() => onChangeHandle(item.title)}
                  >
                    {item.title}
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
      )}

    </div>
  )
}

export default CustomMultiSelectInput
